import { ChakraProvider } from "@chakra-ui/react";
import React, { Suspense, useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import Lights from "../Lights";
import Scene from "./Scene";
import { Leva } from "leva";
import ViewPager from "./ViewPager";
import { Loader } from "./Loader";
import { theme } from "../data/theme";
import { Overlay } from "./Overlay";
import { BackgroundAudio } from './Audio'
import { FullPageModal } from "./FullPageModal";
import { useParams } from "react-router-dom";
import { SERVER_URL } from "../data/constants";

export const PresentationContext = React.createContext(null)

export default function Board() {

    const [error, setError] = useState(null)
    const [boardIsLoaded, setBoardIsLoaded] = useState(false)
    const [board, setBoard] = useState(null)
    const { boardId } = useParams();

    useEffect(() => {
        fetch(`${SERVER_URL}/boards/complete/${boardId}`)
            .then(res => res.json())
            .then((data) => {
                setBoardIsLoaded(true)
                setBoard(data)
            }, (error) => {
                setBoardIsLoaded(false)
                setError(error)
            })
    }, [boardId])

    if (!boardIsLoaded && !error) {
        return (<Loader />)
    }
    // @ts-ignore
    return (
        <ChakraProvider theme={theme}>
            <Canvas
                onCreated={({ gl }: any) => {
                    gl.physicallyCorrectLights = true;
                    gl.outputEncoding = THREE.sRGBEncoding;
                }}
                camera={{ position: [0, 0, 4.5], fov: 40 }}
                dpr={Math.min(window.devicePixelRatio, 2)}
            >
                <Lights />
                <Suspense fallback={null}>
                    <PresentationContext.Provider value={board}>
                        <Scene />
                    </PresentationContext.Provider>
                </Suspense>
                <Leva hidden />
            </Canvas>
            <Suspense fallback={null}>
                <ViewPager />
            </Suspense>
            <Suspense fallback={null}>
                <Overlay />
            </Suspense>
            <Loader />
            <PresentationContext.Provider value={board}>
                <FullPageModal />
            </PresentationContext.Provider>
            <BackgroundAudio />
        </ChakraProvider>
    )
}

